// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import { showErrorMessage } from '../../helpers/showMessage';
import { useNavigate } from 'react-router-dom';
import { profileForgotpassword } from './../../requests/authentication';
import PhoneInput from 'react-phone-input-2';
import { clear, getItem, setItem } from '../../utils/localStorage';
import { EMAIL_REGEX } from '../../utils/regex';
import {
  ForgotPasswordContainer,
  SubTitle,
  TextContainer,
  CTASection,
  Body4Centered,
  TextModal,
} from './ForgotPassword.styled';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { Modal } from './../../app/common/sharedComponents/Modal';
import { useTranslation } from 'react-i18next';
import { PhoneContainer } from './../../app/common/sharedStyledComponents/PhoneInput.styled';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const selectedHotelId = getItem('selectedHotel');
  const selectedClientId = getItem('selectedClient');

  useEffect(() => {
    clear();
    setItem('selectedHotel', selectedHotelId);
    setItem('selectedClient', selectedClientId);
  }, []);

  const handleSubmit = () => {
    if (!email && !phoneNumber) {
      showErrorMessage('Please enter email address');
      return;
    }
    if (email) {
      if (!EMAIL_REGEX.test(email.trim().toLowerCase())) {
        showErrorMessage('Please enter a valid email address');
        return;
      }
    }
    if (phoneNumber) {
      if (phoneNumber.length < 10) {
        showErrorMessage('Please enter a valid phone number');
        return;
      }
    }
    let payload = {};
    if (email) {
      payload = {
        username: email.trim().toLowerCase(),
      };
    } else {
      payload = {
        userPhone: `+${phoneNumber}`.trim(),
      };
    }
    profileForgotpassword(payload)
      .then((res) => {
        navigate('/emailverification');
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.statusCode === 405
        ) {
          // changes
          setModalOpen(true);
        }
      });
  };

  const handleOnChangePhone = (value: string, data: any): any => {
    if (value.slice(data.dialCode.length)) {
      setPhoneNumber(value);
    } else {
      setPhoneNumber(value.slice(data.dialCode.length));
    }
  };

  return (
    <>
      <ForgotPasswordContainer>
        <SubTitle>{t('COMMON.OUTSIDE.MESSAGES.FORGOT_PASSWORD_NOTE')}</SubTitle>
        <ControlInput
          label="Email"
          name="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          type="email"
          required={true}
          hasError={false}
          disabled={!!phoneNumber}
        />
        <TextContainer>or</TextContainer>
        <PhoneContainer>
          <PhoneInput
            country={'us'}
            value={'hi'}
            containerClass="phone-input-dropdown forgot-password"
            dropdownClass={'phone-input-dropdown'}
            onChange={handleOnChangePhone}
            countryCodeEditable={false}
            disabled={!!email}
          />
        </PhoneContainer>
        <CTASection>
          <ButtonLarge title="Reset Password" onClick={() => handleSubmit()} />
          <Body4Centered>Have a code?</Body4Centered>
          <ButtonLarge
            outlined={true}
            inverted={true}
            backgroundColor={'oxfordBlue'}
            title="Enter Code"
            onClick={() => {
              navigate('/emailverification');
            }}
          />
        </CTASection>
      </ForgotPasswordContainer>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          handleModalClose={() => setModalOpen(false)}
          isShowCloseIcon={true}
        >
          <TextModal>
            Your account has been deactivated. If you set up a myLQA membership,
            you may log in with those credentials. If you feel you were
            deactivated in error, please get in touch with your Hotel
            administrator
          </TextModal>
        </Modal>
      )}
    </>
  );
};

export default ForgotPassword;
